export const AbsorbOwnerEnum = {
    VENDOR: "Vendor",
    MERCHANDISE: "Merchandise",
    MARKETING: "Marketing",
  };
  